import NiceModal from "@ebay/nice-modal-react";
import AddIcon from "@mui/icons-material/Add";
import { Fab } from "@mui/material";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import useQueryStringState from "components/hooks/useQueryStringState";
import CustomTable from "components/ui/customs/table/CustomTable";
import { useCallback, useMemo } from "react";
import { useCustomModel } from "components/context/CustomProvider";
import modelConverters from "../table/modelConverters";
import useCustomDataSource from "../useCustomDataSource";

const ModelListPage = ({ page, data }) => {
  const { modelName, itemCreateModal, defaultFilter, predefinedFilters } = page;

  if (!modelName) {
    throw new Error("CustomListPage requires a modelName");
  }

  const model = useCustomModel(modelName);
  const dataSource = useCustomDataSource(modelName);

  const columns = modelConverters.getColumns(model, page);
  const initialState = modelConverters.getInitialState(model, page);

  const [qsState, setQsState] = useQueryStringState({ replace: true });
  const apiRef = useGridApiRef();

  const handleCreateClick = useCallback(() => {
    NiceModal.show(itemCreateModal, {
      parent: data,
      onDone: () => {
        NiceModal.hide(itemCreateModal);
      },
    });
  }, [itemCreateModal, apiRef]);

  const defaultFilterValue = useMemo(() => {
    return defaultFilter ? defaultFilter(data) : undefined;
  }, [defaultFilter, data]);

  return (
    <>
      <CustomTable
        columns={columns}
        initialState={initialState}
        dataSource={dataSource}
        apiRef={apiRef}
        displayState={qsState}
        onDisplayStateChange={setQsState}
        defaultFilter={defaultFilterValue}
        predefinedFilters={predefinedFilters}
      />
      {itemCreateModal && (
        <Fab
          size={"small"}
          sx={{ right: 20, bottom: 20, position: "fixed" }}
          onClick={handleCreateClick}
          disabled={!itemCreateModal}
        >
          <AddIcon />
        </Fab>
      )}
    </>
  );
};

export default ModelListPage;
